import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import FailedIcon from "shared/icons/status-icons/fail-icon.svg?react";

type CriteriaBadgeIconProps = {
  hasCriteria: boolean;
  success: boolean;
  className?: string;
};

export const CriteriaBadgeIcon = ({
  success,
  hasCriteria,
  className
}: CriteriaBadgeIconProps) => {
  if (!hasCriteria) return null;

  const classNames = `no-print shrink-0 stroke-none ${className}`;

  if (success)
    return <SuccessIcon className={`text-success-600 w-5 ${classNames}`} />;

  return <FailedIcon className={`text-danger-500 w-5 ${classNames}`} />;
};
